export const supportedLocales = ['en', 'fr', 'fr-SN', 'fr-FR'];
export const localeCookieKey = 'i18nextLng';

export const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'fr-SN';

export const defaultNamespaces = [
  'common',
  'seo',
  'header',
  'landing',
  'search',
  'home',
  'productScreen',
  'productCard',
];

export function resolveLocale(locale) {
  if (!locale) {
    return defaultLocale;
  }

  const normalized = String(locale).trim();

  if (supportedLocales.includes(normalized)) {
    return normalized;
  }

  const baseLocale = normalized.split('-')[0];
  const matchingLocale = supportedLocales.find(
    (entry) => entry.split('-')[0] === baseLocale,
  );

  return matchingLocale || defaultLocale;
}

export function getLocaleFileKey(locale) {
  return resolveLocale(locale).split('-')[0];
}

export function normalizeLocale(locale) {
  return resolveLocale(locale);
}
